//@ts-ignore
import React, { FC } from 'react';
import { ContainerStyled } from './styled';
import { ContainerProps } from './types';

export const Container: FC<ContainerProps & { children?: any }> = ({ children, ...restProps }) => {
  return (
    <ContainerStyled sx={{ width: restProps.width, height: restProps.height }}>
      {children}
    </ContainerStyled>
  );
};
